module.exports = __webpack_public_path__ + "img/2024.b2ac23e6.jpg";